import contactType from 'helpers/contact_type';

angular.module('gym.contacts', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.contacts', {
    abstract: true,
    template: '<ui-view>',
    url: '/{contactType:prospects|members|non_attending_contacts}?status&credit_card&bank_account&check&defaultFilter',
    resolve: {
      contacts: ["$stateParams", "Members", "Prospects", "NonAttendingContacts", function($stateParams, Members, Prospects, NonAttendingContacts) {
        switch ($stateParams.contactType) {
          case 'prospects':
            return Prospects;
          case 'members':
            return Members;
          case 'non_attending_contacts':
            return NonAttendingContacts;
        }
      }],
      forms: ["gym", "$stateParams", function(gym, $stateParams) {
        switch ($stateParams.contactType) {
          case 'prospects':
            return gym.prospectForms().reload({
              contact_type: 'prospects'
            });
          case 'members':
            return gym.memberForms().reload({
              contact_type: 'members'
            });
          case 'non_attending_contacts':
            return gym.nonAttendingContactForms().reload({
              contact_type: 'non_attending_contacts'
            });
        }
      }]
    }
  }).state('gym.contacts.list', {
    url: '',
    template: require('templates/gyms/contacts/list.html.slim')
  }).state('gym.contacts.merge', {
    url: '^/gyms/:gymId/contact_merges/new?contactId',
    template: require('templates/gyms/contacts/merge.html.slim')
  }).state('gym.contacts.membershipInterruptionRequests', {
    url: '^/gyms/:gymId/membership_interruption_requests?from',
    template: require('templates/gyms/contacts/membership_interruptions_list.html.slim')
  }).state('gym.contacts.membershipInterruptionRequest', {
    url: '^/gyms/:gymId/membership_interruption_requests/:requestId',
    template: require('templates/gyms/contacts/membership_interruption_request.html.slim')
  }).state('gym.contacts.kanban', {
    url: '/kanban',
    template: require('templates/gyms/contacts/kanban.html.slim')
  }).state('gym.contacts.new', {
    url: '/new?relationshipForType&relationshipForId&mobile_app_access_request_id&section',
    templateUrl: function(params) {
      return `/gyms/${params.gymId}/${params.contactType}/new.template`;
    },
    controller: 'NewContactsCtrl',
    resolve: {
      contact: function() {
        return {};
      },
      relationshipForContact: ["$stateParams", "Restangular", function($stateParams, Restangular) {
        if ($stateParams.relationshipForId) {
          return Restangular.one('gyms', $stateParams.gymId).one('contacts', $stateParams.relationshipForId).get();
        } else {
          return {};
        }
      }],
      mobileAppAccessRequest: ["$stateParams", "MobileApp", function($stateParams, MobileApp) {
        if ($stateParams.mobile_app_access_request_id) {
          return MobileApp.one('access_requests', $stateParams.mobile_app_access_request_id).get().then(function(response) {
            return response;
          }, function() {
            return {};
          });
        } else {
          return {};
        }
      }]
    }
  }).state('gym.contacts.contact_log_entries', {
    url: '/{contactId}/contact_log_entries',
    templateUrl: function(params) {
      return `/gyms/${params.gymId}/${params.contactType}/${params.contactId}/contact_log_entries.template`;
    }
  }).state('gym.contacts.edit', {
    url: '/{contactId}?tab&report_referrer&sequence_id&mobile_app_access_request_id&action',
    template: require('templates/gyms/contacts/edit.html.slim'),
    controller: 'EditContactsCtrl',
    resolve: {
      contact: ["$stateParams", "$state", "$window", "Restangular", "$q", function($stateParams, $state, $window, Restangular, $q) {
        var type;
        type = $stateParams.contactType === 'non_attending_contacts' ? $stateParams.contactType : 'contacts';
        return Restangular.one('gyms', $stateParams.gymId).one(type, $stateParams.contactId).get().then(function(contact) {
          var params, url;
          if (contactType(contact.type) !== $stateParams.contactType) {
            params = angular.extend({}, $stateParams, {
              contactType: contactType(contact.type)
            });
            url = $state.href('gym.contacts.edit', params);
            $window.open(url, '_self');
            return $q.reject();
          } else {
            return contact;
          }
        });
      }],
      paymentMethods: ["$stateParams", "gym", "Restangular", function($stateParams, gym, Restangular) {
        var params, payment_system;
        if (gym.attributes.has_payment_provider) {
          payment_system = gym.attributes.payment_system.toLowerCase();
          params = payment_system === 'gocardless' ? {
            wallet: 1
          } : {};
          return Restangular.one('gyms', $stateParams.gymId).one('contacts', $stateParams.contactId).all(payment_system).getList(params);
        } else {
          return [];
        }
      }],
      secondProviderPaymentMethods: ["$stateParams", "gym", "Restangular", function($stateParams, gym, Restangular) {
        var params, payment_system;
        if (gym.attributes.secondary_payment_system) {
          payment_system = gym.attributes.secondary_payment_system.toLowerCase();
          params = payment_system === 'gocardless' ? {
            wallet: 1
          } : {};
          return Restangular.one('gyms', $stateParams.gymId).one('contacts', $stateParams.contactId).all(payment_system).getList(params);
        } else {
          return [];
        }
      }],
      relationships: ["contact", function(contact) {
        return contact.all('contact_relationships').getList();
      }]
    }
  }).state('gym.contacts.membership', {
    url: '/:contactId/memberships/new?membershipReplacementId&targetMembershipId',
    template: require('templates/gyms/contacts/membership.html.slim'),
    controller: 'AddMembershipCtrl',
    resolve: {
      contact: ["AllContacts", "$stateParams", function(AllContacts, $stateParams) {
        return AllContacts().get($stateParams.contactId);
      }],
      newMembershipPlan: ["MembershipPlans", "EmploymentService", function(MembershipPlans, EmploymentService) {
        var permissions;
        permissions = EmploymentService.get().permissions;
        if (!permissions.manage_membership_plans) {
          return {};
        }
        return MembershipPlans.get('new');
      }],
      membershipPlans: ["MembershipPlans", "EmploymentService", function(MembershipPlans, EmploymentService) {
        var params, permissions;
        permissions = EmploymentService.get().permissions;
        params = {
          count: 1000,
          'filters[show_when_adding_membership_internally]': true,
          'sorting[custom]': 'asc'
        };
        return MembershipPlans.getList(params).then(function(membershipPlans) {
          if (permissions.manage_membership_plans) {
            membershipPlans.unshift({
              label: 'Create new Membership Plan'
            });
          }
          return membershipPlans.plain();
        });
      }],
      membershipPlanCategories: ["gym", function(gym) {
        return gym.membershipPlanCategories().reload();
      }],
      eventTypes: ["EventTypes", function(EventTypes) {
        return EventTypes.getList({
          count: 1000
        });
      }],
      gradingStyles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        });
      }]
    }
  }).state('gym.contacts.editMembership', {
    url: '/:contactId/memberships/:membershipId/edit',
    template: require('templates/gyms/contacts/edit_membership.html.slim'),
    controller: 'EditMembershipCtrl',
    resolve: {
      contact: ["AllContacts", "$stateParams", function(AllContacts, $stateParams) {
        return AllContacts().get($stateParams.contactId);
      }],
      membership: ["contact", "$stateParams", function(contact, $stateParams) {
        return _.find(contact.memberships, function(membership) {
          return membership.id === parseInt($stateParams.membershipId, 10);
        });
      }],
      membershipPlanCategories: ["gym", function(gym) {
        return gym.membershipPlanCategories().reload();
      }],
      gradingStyles: ["GradingStyles", function(GradingStyles) {
        return GradingStyles.getList({
          count: 1000,
          slim: 1
        });
      }]
    }
  }).state('gym.contacts.editMembershipExpiration', {
    url: '/:contactId/memberships/:membershipId/change_expiration',
    template: require('templates/gyms/contacts/memberships/edit_membership_expiration.html.slim'),
    controller: 'EditMembershipExpirationCtrl',
    resolve: {
      contact: ["AllContacts", "$stateParams", function(AllContacts, $stateParams) {
        return AllContacts().get($stateParams.contactId);
      }],
      membership: ["contact", "$stateParams", function(contact, $stateParams) {
        return _.find(contact.memberships, function(membership) {
          return membership.id === parseInt($stateParams.membershipId, 10);
        });
      }]
    }
  }).state('gym.contacts.editMembershipRecurringAmount', {
    url: '/:contactId/memberships/:membershipId/change_recurring_amount',
    template: require('templates/gyms/contacts/memberships/edit_membership_recurring_amount.html.slim'),
    controller: 'EditMembershipRecurringAmountCtrl',
    resolve: {
      contact: ["AllContacts", "$stateParams", function(AllContacts, $stateParams) {
        return AllContacts().get($stateParams.contactId);
      }],
      membership: ["contact", "$stateParams", function(contact, $stateParams) {
        return _.find(contact.memberships, function(membership) {
          return membership.id === parseInt($stateParams.membershipId, 10);
        });
      }]
    }
  }).state('gym.contacts.addMembershipCancellation', {
    url: '/:contactId/membership_cancellations/new?membershipId&membershipReplacementId&targetMembershipId&reason',
    template: require('templates/gyms/contacts/memberships/edit_membership_cancellation.html.slim')
  }).state('gym.contacts.editMembershipCancellation', {
    url: '/:contactId/membership_cancellations/:cancellationId/edit',
    template: require('templates/gyms/contacts/memberships/edit_membership_cancellation.html.slim')
  }).state('gym.contacts.membershipCancellation', {
    url: '/:contactId/membership_cancellations/:cancellationId',
    template: require('templates/gyms/contacts/memberships/membership_cancellation.html.slim')
  }).state('gym.contacts.membershipRealignments', {
    url: '/:contactId/membership_realignments/new?invoice_id&from_contact_page',
    template: require('templates/gyms/contacts/memberships/membership_realignments.html.slim'),
    controller: 'MembershipRealignmentsCtrl',
    resolve: {
      invoice: ["Invoices", "$stateParams", function(Invoices, $stateParams) {
        return Invoices.get($stateParams.invoice_id);
      }]
    }
  }).state('gym.contacts.invoicePlanMembershipRealignments', {
    url: '/:contactId/invoice_plan_membership_realignments?membership_id?membership_name',
    template: require('templates/gyms/contacts/memberships/invoice_plan_membership_realignments.html.slim')
  }).state('gym.contacts.newContactStyle', {
    url: '/new/member_styles/new',
    template: require('templates/gyms/contacts/new_contact_style.html.slim'),
    controller: 'NewContactStylesCtrl',
    resolve: {
      forms: ["forms", function(forms) {
        return forms;
      }],
      contact: ["Contacts", function(Contacts) {
        return Contacts.get('new');
      }]
    }
  }).state('gym.contacts.suspension', {
    url: '/:contactId/suspensions/:suspensionId?startOn&endOn&reason&mrId',
    template: require('templates/gyms/contacts/suspensions/edit.html.slim'),
    controller: 'EditSuspensionCtrl',
    resolve: {
      suspension: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        if ($stateParams.suspensionId === 'new') {
          return {};
        }
        url = `/gyms/${$stateParams.gymId}/${$stateParams.contactType}/${$stateParams.contactId}/suspensions/${$stateParams.suspensionId}`;
        return $http.get(url).then(function(response) {
          return response.data;
        });
      }],
      form: ["forms", function(forms) {
        return _.find(forms, {
          name: 'suspensions'
        });
      }],
      contact: ["AllContacts", "$stateParams", function(AllContacts, $stateParams) {
        return AllContacts().get($stateParams.contactId);
      }]
    }
  }).state('gym.contacts.confirmRemoveSuspension', {
    url: '/:contactId/suspensions/:suspensionId/confirm_destroy',
    template: require('templates/gyms/contacts/suspensions/confirm_destroy.html.slim'),
    controller: 'ConfirmRemoveSuspensionCtrl',
    resolve: {
      contact: ["AllContacts", "$stateParams", function(AllContacts, $stateParams) {
        return AllContacts().get($stateParams.contactId);
      }],
      suspension: ["$stateParams", "contact", function($stateParams, contact) {
        var suspension;
        suspension = _.find(contact.suspensions, function(suspension) {
          return suspension.id === parseInt($stateParams.suspensionId, 10);
        });
        return suspension || {};
      }]
    }
  }).state('gym.contacts.waivers', {
    url: '/:contactId/signed_waivers',
    template: '<ui-view>',
    abstract: true
  }).state('gym.contacts.waivers.new', {
    url: '/new?waiver_id',
    template: require('templates/gyms/contacts/waivers/new.html.slim'),
    controller: 'NewContactWaiverCtrl',
    resolve: {
      Contact: ["$stateParams", "contacts", function($stateParams, contacts) {
        return contacts.one($stateParams.contactId);
      }],
      waiver: ["$stateParams", "Contact", function($stateParams, Contact) {
        return Contact.one('signed_waivers', 'new').get({
          waiver_id: $stateParams.waiver_id
        });
      }]
    }
  }).state('gym.contacts.waivers.show', {
    url: '/:waiverId',
    template: require('templates/gyms/contacts/waivers/show.html.slim'),
    controller: 'ShowContactWaiverCtrl',
    resolve: {
      waiver: ["$stateParams", "contacts", function($stateParams, contacts) {
        return contacts.one($stateParams.contactId).one('signed_waivers', $stateParams.waiverId).get();
      }]
    }
  }).state('gym.contacts.performedWorkouts', {
    url: '/:contactId/performed_workouts',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.contacts.performedWorkouts.new', {
    url: '/new?workout_id',
    template: require('templates/gyms/contacts/workouts/edit_performed_workout.html.slim')
  }).state('gym.contacts.performedWorkouts.edit', {
    url: '/:performed_workout_id/edit',
    template: require('templates/gyms/contacts/workouts/edit_performed_workout.html.slim')
  });
}]);
